document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('trade-search-input');
  const typeSelect = document.getElementById('trade-search-type');
  const resultsBox = document.getElementById('predictive-results');

  function clearResults() {
    resultsBox.innerHTML = '';
    resultsBox.style.display = 'none';
  }

  function updatePlaceholder() {
    const type = typeSelect.value;
    clearResults();

    if (type === 'product') input.placeholder = 'Search products…';
    if (type === 'vendor') input.placeholder = 'Search brands…';
    if (type === 'collection') input.placeholder = 'Search collections…';
  }

  typeSelect.addEventListener('change', updatePlaceholder);

  input.addEventListener('input', async () => {
    if (typeSelect.value !== 'product') return clearResults();
    if (input.value.length < 2) return clearResults();

    const url = `/search/suggest.json?q=${encodeURIComponent(input.value)}&resources[type]=product`;

    try {
      const res = await fetch(url);
      const data = await res.json();
      const products = data.resources.results.products;

      if (!products.length) return clearResults();

      resultsBox.innerHTML = products.map(p => `
        <a href="${p.url}" class="predictive-item">
          <span>${p.title}</span>
        </a>
      `).join('');

      resultsBox.style.display = 'block';
    } catch {
      clearResults();
    }
  });

  document.addEventListener('click', e => {
    if (!e.target.closest('.trade-search-wrapper')) {
      clearResults();
    }
  });

  updatePlaceholder();
});
